import { memo } from "react";
import Button from "../button/Button";
import type { IconName } from "@/components/icons/icons";

export interface SecondaryButtonProps {
  label: string;
  colour: "black" | "red" | "white";
  size?: "small" | "medium" | "large";
  disabled?: boolean;
  onClick?: (() => void) | ((data: any) => void);
  icon?: IconName;
  iconPosition?: "left" | "right";
  width?: string;
  iconClassName?: string;
}

const SecondaryButton = ({
  label,
  colour = "red",
  size,
  disabled = false,
  onClick = () => {},
  icon,
  iconPosition,
  iconClassName,
  width,
}: SecondaryButtonProps) => {
  return (
    <Button
      label={label}
      size={size}
      type={`secondary-${colour}`}
      width={width}
      icon={icon}
      iconPosition={iconPosition}
      disabled={disabled}
      onClick={onClick}
      iconClassName={iconClassName}
    />
  );
};

export default memo(SecondaryButton);
